<div>
    <table tsl-table [dataSource]="gridViewData">
        <ng-container tslColumnDef="Entity Name">
            <th tsl-header-cell *tslHeaderCellDef i18n="@@5942643349773319056" t="5942643349773319056" [width]="500">Entity Name </th>
            <td tsl-cell *tslCellDef="let element">
                <div *ngIf="element?.entityName; else empty">{{element?.entityName}}</div>
            </td>
        </ng-container>
        <ng-container tslColumnDef="Region">
            <th tsl-header-cell *tslHeaderCellDef i18n="@@8650097416683280767" t="8650097416683280767" [width]="100">Region </th>
            <td tsl-cell *tslCellDef="let element">
                <div *ngIf="element?.region; else empty">{{element?.region}}</div>
            </td>
        </ng-container>
        <ng-container tslColumnDef="Country">
            <th tsl-header-cell *tslHeaderCellDef i18n="@@Country" t="Country" [width]="200">Country</th>
            <td tsl-cell *tslCellDef="let element">
                <div *ngIf="element?.countryCode; else empty">{{element?.countryCode}}</div>
            </td>
        </ng-container>
        <ng-container tslColumnDef="Category">
            <th tsl-header-cell *tslHeaderCellDef i18n="@@0fbc0bbce830bd50141fac696299f15bed5563c8" t="0fbc0bbce830bd50141fac696299f15bed5563c8" [width]="400"> Category </th>
            <td tsl-cell *tslCellDef="let element">
                <div *ngIf="element?.supplierCategory; else empty">{{element?.supplierCategory}}</div>
            </td>
        </ng-container>
        <ng-container tslColumnDef="Channels">
            <th tsl-header-cell *tslHeaderCellDef i18n="@@3270410178736876464" t="3270410178736876464"> Channels </th>
            <td tsl-cell *tslCellDef="let element">
                <div tsl-cell *ngFor="let channel of element.sources; index as i">
                    <div class="row">
                        <mat-checkbox [(ngModel)]="channel.Enabled" [checked]="channel.Enabled" disabled>{{channel.SourceName}}</mat-checkbox>  
                    </div>
                </div> 
            </td>
        </ng-container>
        <tr tsl-header-row *tslHeaderRowDef="displayedColumns"></tr>
        <tr tsl-row *tslRowDef="let row; columns: displayedColumns;"></tr>
        <ng-template #empty>
            <tsl-icon>maximize</tsl-icon>
        </ng-template>
    </table>
    <div>
        <tsl-pagination [pageSizeOptions]="pageSizeOptions" showFirstLastButtons (pageChange)="pageChange($event)"
          [total]="totalRows" [itemsPerPageLabel]="translateService.get('ItemsPerPage')" [pageSize]="currentPageSize"></tsl-pagination>
    </div>
</div>